// Export the tour steps for Invite Affiliates form fields
export const inviteAffiliateGuideSteps = [
  {
    element: "#invite-affiliates-form-email",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Email Address</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Enter the email address of the affiliate you want to invite to your brand program.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• Use a valid email address format</li>
              <li>• The affiliate will receive an invitation email</li>
              <li>• They can accept or decline the invitation</li>
            </ul>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#invite-affiliates-form-message",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Personal Message</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Write a personalized message to include with your invitation. This helps explain why you want to work with them.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• Introduce your brand and products</li>
              <li>• Explain the benefits of partnering</li>
              <li>• Keep it professional and friendly</li>
              <li>• Maximum 275 characters</li>
            </ul>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#invite-affiliates-form-submit",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Send Invitation</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-sm text-muted-foreground">Send the invitation to the affiliate. They will receive an email with your message and a link to join your program.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <ul class="text-xs text-brand-800 space-y-1">
              <li>• Review your message before sending</li>
              <li>• The affiliate will be notified immediately</li>
              <li>• You can track invitation status</li>
              <li>• You'll be redirected to active affiliates after sending</li>
            </ul>
          </div>
        </div>`,
      side: "top" as const,
      align: "center" as const,
    },
  },
];
